import React from "react";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";


const Others = (props) => {
//   console.log(props.title);
 let paragraphs = props.paragraphs?.map(
    (x) => <p>{x}</p>
);

 let files = (
     
     props.files?.map(
     (x) => (
        <div className="row my-5">
            <div className="col-sm-2">
                <a href={x.url} target="_blank" rel="noopener noreferrer">
                <img alt="Download" className="p-3" src={require ("../img/files/pdf_image.jpg")} />
                    </a>
                
            </div>
            <div className="col-sm-5 f_400">{x.date}</div>
            <div className="col-sm-5 f_400">{x.description}</div>
        </div>         
     )
 ))


  return (
      <div className="body_wrapper">
          <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle={props.title}
        Pdescription=""
      />
    <section className="contact_info_area sec_pad bg_color">
        
      <div className="container">
        <h6 className="f_p f_size_20 t_color3 f_500 mb_20">{props.title}</h6>
        {paragraphs}

        {files}


        
      </div>
      <FooterTwo FooterData={FooterData} />
    </section>
    </div>
  );
};

export default Others;
